import React from "react"
import CloseIcon from "components/Icons/CloseIcon"
import AnimatedImageCarousel from "./AnimatedImageCarousel"
import {
  HeaderOverlay,
  TopBar,
  CloseButton,
  ContentContainer,
  TitleContainer,
  Title,
  SubtitleContainer,
  SubtitleText,
  AnimatedTextContainer,
  AnimatedTextWrapper,
  AnimatedTextItem,
  BetaItem,
} from "./styled"
import { FlexBox } from "components/Common/FlexBox"

interface AnimatedHeaderProps {
  onClose: () => void
}

const ANIMATED_TEXTS = [
  "meals",
  "receipts",
  "packages",
  "nutrition facts",
  "meals",
]

const AnimatedHeader: React.FC<AnimatedHeaderProps> = ({ onClose }) => {
  return (
    <HeaderOverlay>
      <TopBar>
        <CloseButton onClick={onClose} aria-label="Close AI Scanner">
          <CloseIcon fill="#ffffff" />
        </CloseButton>
      </TopBar>

      <ContentContainer>
        <TitleContainer>
          <Title>AI Scanner</Title>
          <SubtitleContainer>
            <SubtitleText>Easily log your</SubtitleText>
            <AnimatedTextContainer>
              <AnimatedTextWrapper>
                {ANIMATED_TEXTS.map((text, index) => (
                  <FlexBox $alignItems="center" $gap={4} key={index}>
                    <AnimatedTextItem key={index}>{text}</AnimatedTextItem>
                    {index === 1 && <BetaItem>Beta</BetaItem>}
                  </FlexBox>
                ))}
              </AnimatedTextWrapper>
            </AnimatedTextContainer>
          </SubtitleContainer>
        </TitleContainer>

        <AnimatedImageCarousel />
      </ContentContainer>
    </HeaderOverlay>
  )
}

export default AnimatedHeader
